
      import '@folkjs/labs/standalone/folk-shape-attribute';

      let el = document.body.firstElementChild.firstElementChild;

      while (el) {
        el.setAttribute('folk-shape', '');
        el = el.nextElementSibling;
      }
    